import React from "react";
import { useTranslation } from "react-i18next";
import { TextButton } from "../TextButton/TextButton";
import { createPortal } from "react-dom";

interface InactivityModalProps {
  secondsLeft: number;
  isVisible: boolean;
  onContinue: () => void;
}

const InactivityModal: React.FC<InactivityModalProps> = ({
  secondsLeft,
  isVisible,
  onContinue,
}) => {
  const { t } = useTranslation();
  if (!isVisible || typeof document === "undefined") return null;

  return createPortal(
    <div className="inactivity-modal__overlay" role="dialog" aria-modal="true">
      <div className="inactivity-modal__content">
        <h2 className="inactivity-modal__heading">
          {t("inactivity.restarting", { seconds: secondsLeft })}
        </h2>
        <div className="inactivity-modal__cta">
          <p className="inactivity-modal__text">{t("inactivity.press")}</p>
          <TextButton id="inactivity-button" label="A" onClick={onContinue} />
          <p className="inactivity-modal__text">{t("inactivity.toContinue")}</p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default InactivityModal;
